import React from "react";

const InfoPage: React.FC = () => {
    React.useEffect(() => {
        document.title=`DimensionX | Real World Metaverse`;
    }, []);

    return (
        <p>Welcome to DimensionX!</p>
    );
};

export default InfoPage;
